import React, { useRef } from 'react';
import "./css/FancyGrid.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';

const FancyGrid = () => {
  const posterRef = useRef(null);
  const videoRef = useRef(null);

  const removePoster = () => {
    if (posterRef.current && videoRef.current) {
      posterRef.current.classList.add("poster-active");
      videoRef.current.play();
      videoRef.current.controls = true;
    }
  };

  return (
    <>
      <main className='main-fancy container'>
        <div className="heading">
          <h1>Safari tours <br />& memories</h1>
          <aside>
            <p>Our tours immerse you in the beauty of the grasslands. Enjoy your time with nature choice of guided day hikes.</p>
            <p>Since 2021</p>
          </aside>
        </div>

        <div className="container">
          {/* Card 1 */}
          <div className="fancy-card">
            <div className="fancy-card-inner">
              <div className="box">
                <div className="imgBox">
                  <LazyLoadImage effect='blur' src={require("../assets/image/hotel_in_kenya_nairobi.jpg")} alt="Awesome views" />
                </div>
                <div className="more">
                  <ul>
                    <li><LazyLoadImage effect='blur' src={require("../assets/image/group_tour_hiking.jpg")} alt="" /></li>
                    <li><LazyLoadImage effect='blur' src={require("../assets/image/desert_trip_kenya.jpg")} alt="" /></li>
                    <li><LazyLoadImage effect='blur' src={require("../assets/image/transport.jpg")} alt="" /></li>
                    <li><LazyLoadImage effect='blur' src={require("../assets/image/naivasha_trip_couple_kenya.png")} alt="" /><span>50+</span></li>
                  </ul>
                </div>
                <div className="tag">
                  <a href="/gallery">#Awesome views</a>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Video */}
          <div className="fancy-card video">
            <div className="fancy-card-inner">
              <div className="box">
                <div
                  className="videoBox poster"
                  ref={posterRef}
                  onClick={removePoster}
                  style={{ cursor: "pointer" }}
                >
                  <video
                    ref={videoRef}
                    width="100%"
                    height="100%"
                    src='https://ik.imagekit.io/joujosafaris/InShot_20250826_124428613.mp4?updatedAt=1756201797003'
                    poster='https://ik.imagekit.io/joujosafaris/InShot_20250826_124428613.mp4?updatedAt=1756201797003/ik-thumbnail,jpg?tr=so-5'
                    controls={false}
                    muted={false}
                  />
                </div>

                <div className="tag">
                  <a href="/about#team">#greatcompany</a>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="fancy-card">
            <p><a href="/about">More about tours</a></p>
            <div className="fancy-card-inner">
              <div className="box">
                <div className="imgBox">
                  <LazyLoadImage effect='blur' src={require("../assets/image/bus_trip_hiking_adventure.jpg")} alt="Hiking" />
                </div>
                <div className="more">
                  <a href="/about" className="arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                  </a>
                </div>
                <div className="tag">
                  <a href="/trips">#explore</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default FancyGrid;